import { css, keyframes } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const appearingAnimation = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const validationContainer = css`
    gap: var(--spacing-2xs);
    padding-top: 16px;
`;

export const ValidationMessage = styled.p`
    margin: 0;

    font-size: 12px;
    font-weight: normal;
    line-height: 14px;
    color: ${Colors.Red.V150};

    animation: ${appearingAnimation} 150ms ease;
`;
